/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const GitBranch: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M18 8.25C18 6.8625 16.932 5.75 15.6 5.75C14.268 5.75 13.2 6.8625 13.2 8.25C13.2 9.1625 13.692 9.975 14.4 10.4V10.775C14.376 11.425 14.124 12 13.644 12.5C13.164 13 12.612 13.2625 11.988 13.2875C10.992 13.3125 10.212 13.4875 9.588 13.85V7.9C10.296 7.475 10.788 6.675 10.788 5.75C10.788 4.3625 9.72 3.25 8.388 3.25C7.056 3.25 6 4.3625 6 5.75C6 6.6625 6.492 7.475 7.2 7.9V16.1C6.492 16.5375 6 17.3375 6 18.25C6 19.6375 7.068 20.75 8.4 20.75C9.732 20.75 10.8 19.6375 10.8 18.25C10.8 17.5875 10.56 17 10.164 16.55C10.272 16.475 10.74 16.0375 10.872 15.9625C11.172 15.825 11.544 15.75 12 15.75C13.26 15.6875 14.34 15.1875 15.3 14.1875C16.26 13.1875 16.74 11.7125 16.8 10.4125H16.776C17.508 9.9625 18 9.1625 18 8.25V8.25ZM8.4 4.25C9.192 4.25 9.84 4.9375 9.84 5.75C9.84 6.5625 9.18 7.25 8.4 7.25C7.62 7.25 6.96 6.5625 6.96 5.75C6.96 4.9375 7.62 4.25 8.4 4.25V4.25ZM8.4 19.7625C7.608 19.7625 6.96 19.075 6.96 18.2625C6.96 17.45 7.62 16.7625 8.4 16.7625C9.18 16.7625 9.84 17.45 9.84 18.2625C9.84 19.075 9.18 19.7625 8.4 19.7625V19.7625ZM15.6 9.7625C14.808 9.7625 14.16 9.075 14.16 8.2625C14.16 7.45 14.82 6.7625 15.6 6.7625C16.38 6.7625 17.04 7.45 17.04 8.2625C17.04 9.075 16.38 9.7625 15.6 9.7625V9.7625Z" />

    </StyledIconBase>
  )
})

GitBranch.displayName = 'GitBranch'

export const GitBranchDimensions = {height: 24, width: 24}
